/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

import type { DataMessageResponse_FavoriteCuisines_ } from "../models/DataMessageResponse_FavoriteCuisines_";
import type { DataResponse_FavoriteCuisines_ } from "../models/DataResponse_FavoriteCuisines_";
import type { FavoriteCuisines } from "../models/FavoriteCuisines";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class FavoriteCuisinesService {
  /**
   * Update Favorite Cuisines
   * Updates the favorite cuisines for a user.
   * @param xUserId
   * @param requestBody
   * @returns DataMessageResponse_FavoriteCuisines_ Successful Response
   * @throws ApiError
   */
  public static updateFavoriteCuisinesApiV1FavoriteCuisinesPut(
    xUserId: string,
    requestBody: FavoriteCuisines,
  ): CancelablePromise<DataMessageResponse_FavoriteCuisines_> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/favorite-cuisines",
      headers: {
        "x-user-id": xUserId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Favorite Cuisines
   * Returns the favorite cuisines for a user.
   * @param xUserId
   * @returns DataResponse_FavoriteCuisines_ Successful Response
   * @throws ApiError
   */
  public static getFavoriteCuisinesApiV1FavoriteCuisinesGet(
    xUserId: string,
  ): CancelablePromise<DataResponse_FavoriteCuisines_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/favorite-cuisines",
      headers: {
        "x-user-id": xUserId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Favorite Cuisines By Admin
   * Used by an admin to get information about a user's favorite cuisines.
   * @param userId
   * @returns DataResponse_FavoriteCuisines_ Successful Response
   * @throws ApiError
   */
  public static getFavoriteCuisinesByAdminApiV1FavoriteCuisinesUserIdGet(
    userId: string,
  ): CancelablePromise<DataResponse_FavoriteCuisines_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/favorite-cuisines/{user_id}",
      path: {
        user_id: userId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
